"use client"

import * as React from "react"
import * as TooltipPrimitive from "@radix-ui/react-tooltip"

import { cn } from "@/lib/utils"

const TooltipProvider = TooltipPrimitive.Provider

const Tooltip = TooltipPrimitive.Root

const TooltipTrigger = TooltipPrimitive.Trigger

const TooltipContent = React.forwardRef<
  React.ElementRef<typeof TooltipPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof TooltipPrimitive.Content>
>(({ className, sideOffset = 4, ...props }, ref) => (
  /* Portal, and the tooltip rung rather than the shadcn overlay default.
     
     Radix does NOT portal tooltip content by default — it renders in place,
     inside whatever the trigger sits in. Every ancestor with `overflow: hidden`
     therefore clips it, and this app has three of them on the common paths: the
     dialog panel, `.scroll-pane` (tab strips, sidebars, sheet bodies) and any
     card with a rounded overflow mask. A tooltip on a control near the edge of a
     dialog was being sliced in half, or vanishing entirely.
     
     Portalling to <body> makes it a sibling of the dialog instead of a child,
     which is what fixes the clipping — and is also exactly why the z-index has
     to move up: as a sibling it no longer inherits the dialog's stacking context,
     so the old 50 rung would put it BEHIND the panel it describes. z-tooltip (160)
     sits above the modal layer and above popovers, per the scale in
     tailwind.config.ts. */
  <TooltipPrimitive.Portal>
  <TooltipPrimitive.Content
    ref={ref}
    sideOffset={sideOffset}
    className={cn(
      "z-tooltip overflow-hidden rounded-xl border-0 shadow-md px-3 py-1.5 text-sm text-foreground animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 origin-(--radix-tooltip-content-transform-origin) bg-popover popover-gradient",
      className
    )}
    {...props}
  />
  </TooltipPrimitive.Portal>
))
TooltipContent.displayName = TooltipPrimitive.Content.displayName

export { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider }
